var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo-complet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 373.06 49.15",
    style: {
      enableBackground: "new 0 0 373.06 49.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B2F4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0.51h27.05v9.52H10.36v9.7h16.69v9.37H10.36v9.96h16.69v9.52H0V0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.62,0.51h11.01l9.65,14.7l9.99-14.7h10.71L61.76,23.35l16.71,25.21h-10.7L56.35,31.49L44.97,48.57H34.04 l16.88-25.18L35.62,0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.08,0.51h16.43c4.42,0,7.98,1.29,10.69,3.86c2.71,2.57,4.06,5.96,4.06,10.16c0,2.76-0.67,5.37-1.99,7.85 c-1.33,2.48-3.34,4.32-6.02,5.54c-2.68,1.22-4.98,1.85-6.88,1.9l-6,0.15v18.59H87.08V0.51z M97.22,9.15v12.3h4.03 c1.73,0,3.21-0.62,4.45-1.87c1.23-1.24,1.85-2.72,1.85-4.43c0-1.95-0.7-3.46-2.09-4.54C104.06,9.54,102.09,9,99.52,9L97.22,9.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.44,0.51h27.05v9.52H138.8v9.7h16.69v9.37H138.8v9.96h16.69v9.52h-27.05V0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.78,0.51h16.4c7,0,12.64,2.21,16.91,6.62c4.27,4.42,6.4,10.24,6.4,17.46c0,7.25-2.2,13.05-6.61,17.42 c-4.41,4.37-10.27,6.55-17.59,6.55h-15.52V0.51z M176.21,9.59v29.68h4.1c4.25,0,7.74-1.16,10.47-3.48c2.73-2.32,4.1-6.19,4.1-11.6 c0-3.15-0.66-5.94-1.98-8.36c-1.32-2.43-3.23-4.07-5.73-4.94c-2.5-0.87-4.89-1.3-7.16-1.3H176.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.79,0.51h10.36v48.06h-10.36V0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.39,0.51h14c5.85,0,9.84,1.22,11.99,3.66c2.15,2.44,3.22,5.29,3.22,8.56c0,2.07-0.39,3.82-1.17,5.25 s-2.04,2.87-3.77,4.33c3.32,1.15,5.67,2.84,7.05,5.07c1.38,2.23,2.07,4.62,2.07,7.16c0,4.42-1.51,7.86-4.53,10.33 c-3.02,2.47-7.28,3.7-12.76,3.7h-16.09V0.51z M246.75,8.56v10.54h2.37c1.75,0,3.22-0.56,4.41-1.67c1.19-1.11,1.79-2.49,1.79-4.13 c0-1.32-0.58-2.44-1.75-3.36c-1.17-0.92-2.62-1.38-4.37-1.38H246.75z M246.75,27.27v13.25h3.71c5.67,0,8.51-2.08,8.51-6.24 c0-2.25-0.69-3.98-2.07-5.19c-1.38-1.21-3.36-1.82-5.93-1.82H246.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.36,24.52c0-7.1,2.35-12.96,7.05-17.59C288.1,2.31,293.67,0,300.12,0c7.12,0,13.02,2.32,17.68,6.97 c4.66,4.65,6.99,10.52,6.99,17.62c0,7.05-2.31,12.91-6.92,17.57c-4.61,4.66-10.42,6.99-17.42,6.99s-12.77-2.32-17.29-6.96 C278.62,37.56,276.36,31.67,276.36,24.52z M300.59,9.59c-4.03-0.07-7.27,1.32-9.74,4.17c-2.46,2.85-3.7,6.54-3.7,11.05 c0,4.27,1.26,7.81,3.77,10.61c2.51,2.81,5.68,4.21,9.52,4.21c4.03,0,7.28-1.38,9.75-4.15s3.72-6.42,3.72-10.96 c0-4.47-1.21-8.05-3.64-10.76S304.62,9.66,300.59,9.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.2,0.51h11.01l9.65,14.7l9.99-14.7h10.71l-15.21,22.84l16.71,25.21h-10.7l-11.43-17.08l-11.37,17.08 h-10.93l16.88-25.18L330.2,0.51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dfef474b.svg";
export { ForwardRef as ReactComponent };